const components = import.meta.globEager('./common/**/*.vue')
const exportComponents = []

for (const key in components) {
  if (components[key].default.name) {
    let name = components[key].default.name
    exportComponents.push({ name: `td${name}`, component: components[key].default })
  }
}
export default exportComponents
